/**
 * Legends
 * urlParam:  true & valid value
 * nexla.com? key=<ValidValue>
 *
 * * urlParam:  true & not valid value
 * nexla.com
 *
 * * * urlParam:  false & valid value
 * nexla.com
 */
const NM_TEMPLATES = {
  nexla_monitor: [
    {
      label: 'Flow Metrics',
      id: 'fetch_resource_flow_metrics',
      description:
        'Use this endpoint to fetch the metrics for each node of a flow that includes the selected Source, Nexset, or Destination.',
      config: {
        'rest.iterations': [
          {
            method: 'GET',
            key: 'step1',
            isPaginated: false,
            'url.template': '/${resource_type}/${resource_id}/${resource_url}',
            'response.data.path': '$.metrics.data',
            'iteration.type': 'static.url',
            'date.format': 'yyyy-MM-dd',
            'date.time.unit': 'dd',
          },
        ],
        'start.cron': '${start.cron}',
      },
      fields: [
        {
          name: 'resource_type',
          display_name: 'Flow for Resource Type',
          description: 'Select the resource type whose flow metrics you wish to fetch.',
          inputType: 'select',
          required: true,
          default: 'flows',
          type: 'string',
          options: [
            { value: 'flows', label: 'Flow' },
            { value: 'data_sources', label: 'Source' },
            { value: 'data_sets', label: 'Nexset' },
            { value: 'data_sinks', label: 'Destination' },
          ],
        },
        {
          name: 'resource_id',
          display_name: 'Resource ID',
          description: 'ID of Nexla Source / Nexset/ Destination',
          inputType: 'text',
          required: true,
          type: 'int',
        },
        {
          name: 'resource_url',
          display_name: 'Resource URL',
          description: 'URL of Nexla Source / Nexset/ Destination',
          inputType: 'text',
          required: true,
          type: 'string',
          isHiddenField: true,
          conditionalDefault: true,
          defaults: [
            {
              dependsOn: 'resource_type',
              dependsOnValues: ['data_sources', 'data_sets', 'data_sinks'],
              defaultValue: '/flow/metrics',
            },
            {
              dependsOn: 'resource_type',
              dependsOnValues: ['flows'],
              defaultValue: '/metrics',
            },
          ],
        },
        {
          name: 'interval',
          display_name: 'Interval',
          description: 'Add Interval',
          inputType: 'select',
          required: true,
          default: 'lifetime',
          type: 'string',
          urlParam: true,
          ignoreIf: {
            name: 'interval',
            oneOfValues: ['other'],
            ignoreIfEmpty: false,
          },
          options: [
            { value: 'lifetime', label: 'Lifetime' },
            { value: 'other', label: 'Other' },
          ],
          values: ['lifetime', 'other'],
        },
        {
          name: 'from',
          display_name: 'From',
          description: 'Interval start date',
          inputType: 'text',
          required: false,
          urlParam: true,
          type: 'datetime',
          validations: {
            notNull: true,
          },
          dependsOn: {
            name: 'interval',
            value: 'other',
            ignoreIfEmpty: false,
          },
        },
        {
          name: 'to',
          display_name: 'To',
          description: 'Interval ends date',
          inputType: 'text',
          required: false,
          urlParam: true, // if set true and get valid value, then this field get's append in the URL
          type: 'datetime',
          validations: {
            notNull: true,
          },
          dependsOn: {
            name: 'interval',
            value: 'other',
            ignoreIfEmpty: false,
          },
        },
      ],
    },
    {
      label: 'User / Org Active Resource Performance (Last 24 Hours)',
      id: 'fetch_flow_dashboard_metrics',
      description:
        'Use this endpoint to fetch the metrics for each active resource that processed data in the last 24 hours. Org admins can configure requests for their entire organization or specific users., while non-admin users can only fetch data for their account.',
      config: {
        'rest.iterations': [
          {
            method: 'GET',
            key: 'step1',
            isPaginated: false,
            'url.template': '/${resource_type}/${resource_id}/flows/dashboard',
            'response.data.path': '$.metrics',
            'iteration.type': 'static.url',
            'date.format': 'yyyy-MM-dd',
            'date.time.unit': 'dd',
          },
        ],
        'start.cron': '${start.cron}',
      },
      fields: [
        {
          name: 'resource_type',
          display_name: 'Resource Type (Org/User)',
          description: 'Select whether you wish to fetch data for a user or the entire org.',
          inputType: 'select',
          required: true,
          default: 'users',
          type: 'string',
          options: [
            { value: 'users', label: 'User' },
            { value: 'orgs', label: 'Org' },
          ],
          values: ['users', 'orgs'],
        },
        {
          name: 'resource_id',
          display_name: 'Resource ID',
          description: 'ID of Org / User',
          inputType: 'text',
          required: true,
          type: 'int',
        },
      ],
    },
  ],
};

export default NM_TEMPLATES;
